/* eslint-disable react/jsx-no-target-blank, no-debugger */
import api, { getJson } from "../helpers/axiosHelper";

import {
  API_ROOT_URL,
  CREATE_ROOM,
  GET_GLOBAL_TAGS,
  GET_PROJECT_API,
  ORGANISATION_DETAILS_API,
  PROPS_API,
  ROOM_DETAILS_API,
  ROOM_LAYOUT_API,
  GET_SETTING_API,
  EDIT_SETTING_API,
  CREATE_SETTINGS_API,
  GET_DEFAULT_METADATA,
  AUTOSAVE_API,
  ONBOARDING_ROOM_DETAILS_API,
  PROP_GROUP_API,
  PROP_GROUP_OVERWRITE_API,
  GET_GROUP_PROP_LIST_API,
  PRODUCT_GROUP_FOR_NORMAL_USER_API,
  OP_GET_ROOMS_API,
  MATTRESS_PROPS_API,
} from '../config/constant/apiConstant';
import {
  editCuratorSettingData,
  getCuratorSettingData,
  selectIndividualProjectData,
  selectInitialRoomJsonData,
  selectIsV1UploadedProject,
  selectProjectJsonUrl,
  selectProjectOwner,
  setAllOnboardingData,
  setDefaultMetaData,
  setIndividualProjectData,
  setLayoutData,
  setOnboardingProducts,
  setRoomData,
  setSaveProjectLoading,
} from '../redux/slicers/admin/curatorSlicer';
import { dispatcher } from '../helpers/projectHelper';
import { errorToast, successToast } from '../helpers/toastHelper';
import { setOrganisationData } from '../redux/slicers/organisation/organisationSlicer';
import { setTagData } from '../redux/slicers/tags/globalTagSlicer';
import { CURATOR_SETTING } from '../config/indexDB/schema';
import { getLocalStorage, objectToSearchParams } from '../helpers/jsHelper';
import { setGlobalHeight, setGlobalWidth } from '../redux/slicers/camera/cameraSettings';
import { selectProjectCameraList } from '../redux/slicers/camera/projectCameraAngleSlicer';
import { getAppState } from '../redux/store';
import { EXPORT_PROJECT, GET_SIDE_PANEL_OPTIONS, SIDE_PANEL_OPTIONS } from '../helpers/api';
import {
  setConfig,
  setUserEnabledSections,
} from '../redux/slicers/admin/curatorMenuPreferencesSlicer';
import downloadjs from 'downloadjs';
import { resetCreatedLists } from '../redux/slicers/admin/paginatedRenderPreviewsSlicer';
import {
  DEFAULT_HORIZONTAL_ROTATION_SPEED,
  DEFAULT_PAN_SPEED,
  DEFAULT_VERTICAL_ROTATION_SPEED,
  DEFAULT_ZOOM_SPEED,
} from '../constants/validationConstants';
import { setBackupData, setUpdating } from '../redux/slicers/admin/curatorBackupSlicer';
import { MEMBER_ID } from '../constants/projectConstants';
import { isEmpty, sortBy } from 'lodash';
import { LogCurator } from '../helpers/logEvents';

export const layoutApi = () => (dispatch) => {
  api()
    .root(API_ROOT_URL)
    .get(ROOM_LAYOUT_API)
    .success((data) => {
      dispatch(setLayoutData(data));
    })
    .error(() => {})
    .send();
};

export const getOnboardingRoomDetailsApi = (roomId) => (dispatch) => {
  return api()
    .root(API_ROOT_URL)
    .get(`${ONBOARDING_ROOM_DETAILS_API}${roomId}`)
    .success(async (data) => {
      const roomData = {
        ...data.room_data,
        customName: data.name,
      };
      dispatch(setRoomData(roomData));
      const highlightObject = data.tutorial_products_data.find((val) => val.highlight_object);
      let defaultObject = {};
      if (isEmpty(highlightObject)) {
        defaultObject = data.tutorial_products_data.find((val) => val.is_default);
      } else {
        defaultObject = highlightObject;
      }
      let json = {};
      let otherJson = {};
      if (defaultObject?.json_file) {
        json = await getJson(defaultObject?.json_file);
      }
      if (data?.other_object_data?.json_file) {
        otherJson = await getJson(data?.other_object_data?.json_file);
      }
      console.warn('JSON data', json, otherJson);
      dispatch(
        setAllOnboardingData({
          ...defaultObject,
          other_object_data: {
            ...data.other_object_data,
            toolTipPosition: otherJson?.toolTipPosition,
            isWall: otherJson?.isWall || false,
          },
          initial_camera_angle: json?.initialCameraAngle,
          final_camera_angle: json?.finalCameraAngle,
          tutorial_room_id: data.id,
          toolTipPosition: json?.toolTipPosition,
          room_id: data.room,
        })
      );
      let productsData = defaultObject?.replaceable_product_data;
      productsData = productsData.map((val) => {
        const data = {
          ...val.product_data,
          styling_object_name: val.styling_object_name,
          is_disabled: !val.is_enabled,
          materials_data: val.materials_data,
        };
        return data;
      });
      const finalData = sortBy(productsData, ['is_disabled']);
      dispatch(setOnboardingProducts(finalData));
    })
    .error(() => {})
    .send();
};

export const getRoomDetailsApi =
  ({ ids, ...rest } = {}) =>
  (dispatch) => {
    let query = '';

    if (ids) {
      query = ids.map((a) => `id=${a}`).join('&');
    } else {
      query = objectToSearchParams(rest).toString();
    }

    return api()
      .root(API_ROOT_URL)
      .get(`${ROOM_DETAILS_API}?${query}`)
      .success((data) => {
        dispatch(setRoomData(data.results?.[0]));
      })
      .error(() => {})
      .send();
  };

export const getRoomDetailsApiV2 =
  ({ ids, ...rest } = {}) =>
  (dispatch) => {
    let query = '';

    if (ids) {
      query = ids.map((a) => `id=${a}`).join('&');
    } else {
      query = objectToSearchParams(rest).toString();
    }

    return api()
      .root(API_ROOT_URL)
      .get(`${OP_GET_ROOMS_API}?${query}`)
      .success((data) => {
        dispatch(setRoomData(data.results?.[0]));
      })
      .error(() => {})
      .send();
  };

// Create Room
export const createRoomApi = (formData) => (dispatch) => {
  return api()
    .root(API_ROOT_URL)
    .post(CREATE_ROOM)
    .data(formData)
    .success((data) => {
      // navigate(TEMPLATES_ROUTE);
      successToast('Room created successfully');
      localStorage.removeItem('roomInfo');
      LogCurator('Curator', data);
    })
    .error((err) => {
      err?.message?.name?.[0] && errorToast(err?.message?.name?.[0]);
      console.error(err);
    })
    .send();
};

// Create prop group
export const createPropGroupApi = (formData) => (dispatch) => {
  return api()
    .root(API_ROOT_URL)
    .post(PROP_GROUP_API)
    .data(formData)
    .success((data) => {
      // navigate(TEMPLATES_ROUTE);
      successToast('Product group has been created successfully.');
      // localStorage.removeItem("roomInfo");
      LogCurator('Curator product grouped', data);
    })
    .error((err) => {
      err?.message?.name?.[0] && errorToast(err?.message?.name?.[0]);
      console.error(err);
    })
    .send();
};

// Create product group
export const createProductGroupForNormalUserApi = (formData) => (dispatch) => {
  return api()
    .root(API_ROOT_URL)
    .post(PRODUCT_GROUP_FOR_NORMAL_USER_API)
    .data(formData)
    .success((data) => {
      successToast('Product group has been created successfully.');
      LogCurator('Curator product grouped', data);
    })
    .error((err) => {
      err?.message?.name?.[0] && errorToast(err?.message?.name?.[0]);
      console.error(err);
    })
    .send();
};

export const overwritePropGroupApi = ({ formData, groupId }) => (dispatch) => {
  const endpoint = PROP_GROUP_OVERWRITE_API.replace(':groupId', groupId);

  return api()
    .root(API_ROOT_URL)
    .patch(endpoint)
    .data(formData)
    .success((data) => {
      successToast('Product group has been overwritten successfully.');
      LogCurator('Curator product group overwritten', data);
    })
    .error((err) => {
      err?.message?.name?.[0] && errorToast(err?.message?.name?.[0]);
      console.error(err);
    })
    .send();
};

export const getPropGroupListApi = (id) => {
  return api()
    .root(API_ROOT_URL)
    .get(`${GET_GROUP_PROP_LIST_API}?prop_id=${id}`)
    .success((data) => {
      LogCurator('Curator get prop grouped ID', data);
      return data;
    })
    .error((err) => {
      errorToast(err?.message || 'Unable to get prop. Please again later!');
      console.error(err);
    })
    .send();
};

export const mattressPropsReadApi = async (arr = [], page = 1, params = null) => {
  let query = arr.map((a) => `id=${a}`).join('&');
  if (params) query += `&${params}`;
  return await api()
    .root(API_ROOT_URL)
    .get(`${MATTRESS_PROPS_API}?${query}&per_page=20&page=${page}`)
    .send();
};

export const propsReadApi = async (arr = [], page = 1, params=null) => {
  let query = arr.map((a) => `id=${a}`).join("&");
  if (params)
    query += `&${params}`;
  return await api()
    .root(API_ROOT_URL)
    .get(`${PROPS_API}?${query}&per_page=20&page=${page}`)
    .send();
};
export const propsV1ReadApi = async (arr = []) => {
  const query = `old_product_id=${arr.join(",")}`;
  // const query = arr.map((a) => `old_product_id=${a}`).join('&');
  return await api()
    .root(API_ROOT_URL)
    .get(`${PROPS_API}?${query}&per_page=100`)
    .send();
};
export const uniquePropsApi = async (id = "") => {
  return await api().root(API_ROOT_URL).get(`${PROPS_API}?id=${id}`).send();
};

export const layoutReadApi = async (id = "") => {
  return await api()
    .root(API_ROOT_URL)
    .get(`${ROOM_LAYOUT_API}${id}/`)
    .success((data) => {})
    .send();
};
export const createProjectApi = (formData, { onSuccess, onError } = {}) => (
  dispatch
) => {
  dispatch(setSaveProjectLoading(true));
  api()
    .root(API_ROOT_URL)
    .post(GET_PROJECT_API)
    .data(formData)
    .success((data) => {
      //TODO Move save mixpanel event here
      successToast(`Project created successfully.`);
      dispatch(resetCreatedLists());
      onSuccess?.(data);
    })
    .error(() => {
      errorToast("Unknown error happened while creating project");
      onError?.();
    })
    .upload(() => {})
    .finally(() => {
      dispatch(setSaveProjectLoading(false));
    });
};

export const getProjectApi = (formData) => (dispatch) => {
  api()
    .root(API_ROOT_URL)
    .get(`${GET_PROJECT_API}${formData}/`)
    .data(formData)
    .success((data) => {
      dispatch(setIndividualProjectData(data));
    })
    .error(() => {})
    .upload(() => {});
};

export const saveProjectApi = (formData, id, { onSuccess, onError } = {}) => (
  dispatch
) => {
  dispatch(setSaveProjectLoading(true));
  api()
    .root(API_ROOT_URL)
    .patch(`${GET_PROJECT_API}${id}/`)
    .data(formData)
    .success((data) => {
      successToast("Project updated successfully");
      dispatch(resetCreatedLists());
      dispatch(setIndividualProjectData(data.data));
      onSuccess?.(data.data);
    })
    .error(() => onError?.())
    .upload(() => {})
    .finally(() => {
      dispatch(setSaveProjectLoading(false));
    });
};

export const createProjectBackup = ({ formData }) => (dispatch) => {
  dispatch(setUpdating(true));

  return api()
    .root(API_ROOT_URL)
    .post(AUTOSAVE_API)
    .data(formData)
    .success((data) => {
      const autoSaveData = data.data;
      dispatch(setBackupData(autoSaveData));
    })
    .error(() => {
      console.log("error!!!");
    })
    .upload()
    .finally(() => {
      dispatch(setUpdating(false));
    });
};

export const updateProjectBackup = ({ projectId, formData }) => (dispatch) => {
  dispatch(setUpdating(true));

  return api()
    .root(API_ROOT_URL)
    .patch(`${AUTOSAVE_API}${projectId}/`)
    .data(formData)
    .success((data) => {})
    .error(() => {
      console.log("error!!!");
    })
    .upload()
    .finally(() => {
      dispatch(setUpdating(false));
    });
};

export const saveCurrentProjectCameras = async ({
  onError,
  onSuccess,
} = {}) => {
  const projectOwner = selectProjectOwner(getAppState());

  // preventing api call for non owner of the project while saving
  if (getLocalStorage(MEMBER_ID, true) !== projectOwner?.member_id) return;

  const projectId = selectIndividualProjectData(getAppState()).id;
  const jsonFileUrl = selectProjectJsonUrl(getAppState());

  let projectJson;
  const isV1UploadedProject = selectIsV1UploadedProject(getAppState());

  if (isV1UploadedProject) {
    projectJson = { ...selectInitialRoomJsonData(getAppState()) };
  } else {
    projectJson = await getJson(jsonFileUrl);
  }

  projectJson.cameraList = selectProjectCameraList(getAppState()) || [];
  const jsonData = JSON.stringify(projectJson);

  LogCurator("sasha jsonData", jsonData);

  const blob = new Blob([jsonData], { type: "application/json" });
  var formData = new FormData();
  formData.append("file", blob, "newproject.json");

  return api()
    .root(API_ROOT_URL)
    .patch(`${GET_PROJECT_API}${projectId}/`)
    .data(formData)
    .success((data) => {
      dispatcher(setIndividualProjectData(data.data));
      onSuccess?.();
    })
    .error(() => {
      errorToast(
        'Something went wrong during updating camera list. Please save project using "Save" in navigation menu '
      );
      onError?.();
    })
    .upload(() => {});
};

// Live on App APIs start
export const getOrganisationsApi = (page = 1) => (dispatch) => {
  api()
    .root(API_ROOT_URL)
    .get(`${ORGANISATION_DETAILS_API}?page=${page}`)
    .success((data) => dispatch(setOrganisationData(data)))
    // .success((data) => console.table(data.results))
    .error((error) => console.error("Error occured: ", error.message))
    .send();
};

export const getCuratorSettings = ({ userId }) => (dispatch) => {
  return api()
    .root(API_ROOT_URL)
    .get(`${GET_SETTING_API}`)
    .success((data) => {
      if (!data?.json_data) {
        return dispatch(getDefaultMetaData({ userId }));
      } else {
        if (data?.json_data?.metaData) {
          let tempMetaData = [...data?.json_data?.metaData];
          data?.default_meta_data?.forEach((newMetaData) => {
            let flag = true;
            data?.json_data?.metaData?.forEach((oldMetaData) => {
              if (oldMetaData?.id === newMetaData?.id) {
                flag = false;
              }
            });
            if (flag) {
              tempMetaData.push({
                ...newMetaData,
                seq_no: tempMetaData?.length,
              });
            }
          });

          let presets = data?.json_data?.resolutionPresent;
          if (presets && presets.length) {
            let selectedPreset = presets.find((p) => p.isSelected);
            if (!selectedPreset) {
              presets = presets.map((p, idx) =>
                idx === 0 ? { ...p, isSelected: true } : p
              );
            }

            selectedPreset = presets.find((p) => p.isSelected);
            dispatch(setGlobalWidth(selectedPreset.width));
            dispatch(setGlobalHeight(selectedPreset.height));
          }

          // parse camera settings
          const defaultCameraSettings = {
            verticalRotationSpeed: DEFAULT_VERTICAL_ROTATION_SPEED,
            horizontalRotationSpeed: DEFAULT_HORIZONTAL_ROTATION_SPEED,
            zoomSpeed: DEFAULT_ZOOM_SPEED,
            panSpeed: DEFAULT_PAN_SPEED,
          };

          const cameraSetting = {
            ...defaultCameraSettings,
            ...data?.json_data?.cameraSetting,
          };
          dispatch(
            getCuratorSettingData({
              ...data,
              json_data: {
                ...data?.json_data,
                metaData: tempMetaData,
                resolutionPresent: presets,
                cameraSetting,
              },
            })
          );
        }
      }
    })
    .error((error) => {
      errorToast("Unable to get settings, please try to reload the page");
      console.log("getCuratorSettings error", error);
    })
    .send();
};

export const createCuratorSettings = (formData) => (dispatch) => {
  return api()
    .root(API_ROOT_URL)
    .post(`${CREATE_SETTINGS_API}`)
    .data(formData)
    .send()
    .then((data) => {
      const firstResolutionPreset = data?.json_data?.resolutionPresent?.[0];

      if (firstResolutionPreset?.id) {
        dispatch(setGlobalWidth(firstResolutionPreset.width));
        dispatch(setGlobalHeight(firstResolutionPreset.height));
      }
      dispatch(getCuratorSettingData(data));
      return data;
    })
    .catch(() => {
      errorToast("Could not cerate settings");
    });
};

export const editCuratorSetting = (formData, id) => (dispatch) => {
  api()
    .root(API_ROOT_URL)
    .patch(`${EDIT_SETTING_API}${id}/`)
    .data(formData)
    .send()
    .then((data) => {
      dispatch(editCuratorSettingData(data));
    })
    .catch((error) => {
      console.log("error", error);
      errorToast("something went wrong");
    });
};
export const getGlobalTagsApi = () => (dispatch) => {
  api()
    .root(API_ROOT_URL)
    .get(GET_GLOBAL_TAGS)
    .success((data) => dispatch(setTagData(data)))
    .error((error) => console.error("Error occured: ", error.message))
    .send();
};

export const getDefaultMetaData = ({ userId }) => (dispatch) => {
  return api()
    .root(API_ROOT_URL)
    .get(GET_DEFAULT_METADATA)
    .send()
    .then((data) => {
      dispatch(setDefaultMetaData(data));
      const formData = new FormData();
      formData.append(
        "json_data",
        JSON.stringify({ ...CURATOR_SETTING, metaData: data?.results })
      );
      LogCurator("default_data", data);
      formData.append("user", parseInt(userId));
      dispatch(createCuratorSettings(formData));
      // editCuratorSetting()
    });
};
// Live on App APIs end

export const getSidePanelOptionsApi = () => (dispatch) => {
  return api()
    .root(API_ROOT_URL)
    .get(GET_SIDE_PANEL_OPTIONS)
    .success((data) => {
      dispatch(setUserEnabledSections(data));
      LogCurator("getSidePanelOptionsApi ", data);
    })
    .send();
};

export const getSidePanelOptionsConfigApi = () => (dispatch) => {
  return api()
    .root(API_ROOT_URL)
    .get(SIDE_PANEL_OPTIONS)
    .success((data) => {
      dispatch(setConfig(data.results));
    })
    .send();
};

export const updateSidePanelOptionsApi = ({ ids }) => (dispatch) => {
  const formData = new FormData();
  formData.append("id", ids.join(","));

  return api()
    .root(API_ROOT_URL)
    .data(formData)
    .post(GET_SIDE_PANEL_OPTIONS)
    .error((err) => {
      errorToast("Unable to save sidebar panel configuration at this time");
    })
    .send();
};

export const exportProjectApi = (formData, { fileName }) => async (
  dispatch
) => {
  const result = await api()
    .root(API_ROOT_URL)
    .post(EXPORT_PROJECT)
    .data(formData)
    .send();

  const fileUrl = result?.data?.zip_file;

  if (!fileUrl) {
    // error is already handled above
    return;
  }

  return fileUrl;
};

export const downloadFile = (fileUrl, fileName) => {
  // this one is temporary until we prepare download progress component

  return new Promise((resolve, reject) => {
    var x = new XMLHttpRequest();
    x.open("GET", fileUrl, true);
    x.responseType = "blob";
    x.onload = function (e) {
      downloadjs(e.target.response, fileName);
      resolve(undefined);
    };
    x.send();
  });
};

export const downloadFileAsJPEG = (fileUrl, fileName, callback) => {
  // this one is temporary until we prepare download progress component

  return new Promise((resolve, reject) => {
    var x = new XMLHttpRequest();
    x.open('GET', fileUrl, true);
    x.responseType = 'blob'; // Set response type to 'blob'

    x.onload = function () {
      if (x.status === 200) {
        // Create an image element to load the blob data
        const img = new Image();
        const blob = x.response;
        const objectURL = URL.createObjectURL(blob);
        img.onload = function () {
          // Create a canvas to draw the image and convert it to JPEG
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          // Set canvas dimensions to the image's dimensions
          canvas.width = img.width;
          canvas.height = img.height;

          // Draw the image onto the canvas
          ctx.drawImage(img, 0, 0);

          // Convert the canvas content to JPEG format
          const jpegDataUrl = canvas.toDataURL('image/jpeg');
          callback?.();
          // Create a temporary download link
          const link = document.createElement('a');
          link.href = jpegDataUrl;
          link.download = fileName || 'image.jpg'; // Set the file name for download
          link.click(); // Trigger the download
        };
        img.src = objectURL; // Set the image source to the object URL created from the blob
      } else {
        console.error('Failed to download file: ' + x.status);
      }
    };

    x.onerror = function () {
      console.error('Network error while downloading file.');
    };

    x.send(); // Send the request to fetch the image
  });
};

export async function jpegFileFromBlobUrl(blobUrl, fileName) {
  const img = new Image();
  img.crossOrigin = "anonymous"; // safe even for blob URLs

  await new Promise((resolve, reject) => {
    img.onload = resolve;
    img.onerror = reject;
    img.src = blobUrl;
  });

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  canvas.width = img.width;
  canvas.height = img.height;

  ctx.drawImage(img, 0, 0);

  const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg'));

  const file = new File([blob], fileName, { type: 'image/jpeg' });

  return file;
}
